// extracted by mini-css-extract-plugin
export var divider = "_mk-0";
export var systemMessage = "_mk-1";
export var systemMessageWrapper = "_mk-2";